export enum RecallType {
    Assigned = 1,
    Validated = 2
}